import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthProvider';
import LoginPage from "./components/layout/LoginPage";
import VerifyEmailResult from "./components/parts/Auth/VerifyEmailResult";
import RegisterPage from "./components/layout/RegisterPage";
import RegisterCompany from "./components/layout/Registration/RegisterCompany";
import Dashboard from "./components/parts/Dashboard";
import RetailerSetup from './components/parts/Onboarding/RetailerSetup';
import Transactions from "./components/parts/Transactions/Transactions";
import VenueCreate from "./components/parts/Venues/VenueCreate";
import Venues from "./components/parts/Venues/Venues";
import VenueView from "./components/parts/Venues/VenueView";
import Items from "./components/parts/Items/Items";
import Products from "./components/parts/Products/Products";
import ProductView from "./components/parts/Products/ProductView";
import ProfilePage from "./components/parts/Profile/ProfilePage";
import ViewItem from "./components/parts/Items/Item/ViewItem";
import Warranties from "./components/parts/Warranties/Warranties"; // New parent component
import CampaignList from "./components/parts/campaign/CampaignList";
import CampaignCreate from "./components/parts/campaign/CampaignCreate";
import CampaignEdit from "./components/parts/campaign/CampaignEdit";
import AuthorizedServiceCenters from "./components/parts/AuthorizedServiceCenters";
import POSIntegration from "./components/parts/Integrations/POSIntegration";
import Settings from "./components/parts/Settings/Settings";
import MyPlan from './components/parts/Plan/MyPlan';
import RetailerPartnerReferral from './components/parts/Integrations/RetailerPartnerReferral';
import CatalogImportWorkspace from './components/parts/CatalogSources/CatalogImportWorkspace';
import RetailerCategoryMappings from './components/parts/CatalogSources/RetailerCategoryMappings';
import DiscoveryStats from './components/parts/Stats/DiscoveryStats';
import OrganizationDetail from "./components/parts/OrganizationDetail";
import AuthLayout from "./layouts/AuthLayout";
import MainLayout from "./layouts/MainLayout";
import Users from "./components/parts/Users/Users";
import CustomerDetails from "./components/parts/Users/CustomerDetails";
import OrganizationUsers from "./components/parts/Users/OrganizationUsers";
import ForgotPasswordPage from "./components/layout/ForgotPasswordPage";
import CampaignWizard from "./components/parts/campaign/CampaignWizard";
import RepairSettingsPage from "./components/parts/RepairSettingsPage";
import Integrations from "./components/parts/Integrations/Integrations";
// import ManufacturerNavigation from "./components/layout/ManufacturerNavigation"; // DELETED
import ManufacturerDashboard from "./components/parts/manufacturer/ManufacturerDashboard";
import ManufacturerProducts from "./components/parts/manufacturer/products/ManufacturerProducts";
import ManufacturerProductDetail from "./components/parts/manufacturer/products/ManufacturerProductDetail";
import ManufacturerRetailers from "./components/parts/manufacturer/retailers/ManufacturerRetailers";
import ManufacturerRetailerDetail from "./components/parts/manufacturer/retailers/ManufacturerRetailerDetail";
import ManufacturerDistributors from "./components/parts/manufacturer/distributors/ManufacturerDistributors";
import ManufacturerDistributorDetail from "./components/parts/manufacturer/distributors/ManufacturerDistributorDetail";
import ManufacturerVenues from "./components/parts/manufacturer/venues/ManufacturerVenues";
import ManufacturerVenueDetail from "./components/parts/manufacturer/venues/ManufacturerVenueDetail";
import ManufacturerTransactions from "./components/parts/manufacturer/transactions/ManufacturerTransactions";
import ManufacturerWarrantiesPage from "./components/parts/manufacturer/warranties/ManufacturerWarranties";
import ManufacturerSupport from "./components/parts/manufacturer/support/ManufacturerSupport";
import ManufacturerSettings from "./components/parts/manufacturer/settings/ManufacturerSettings";
import ManufacturerIntegrations from "./components/parts/manufacturer/integrations/ManufacturerIntegrations";
import ManufacturerImportExport from "./components/parts/manufacturer/importExport/ManufacturerImportExport";
import ManufacturerCompliance from "./components/parts/manufacturer/compliance/ManufacturerCompliance";
import ManufacturerDiscounts from "./components/parts/manufacturer/discounts/ManufacturerDiscounts";
import ManufacturerProductApprovals from "./components/parts/manufacturer/approvals/ManufacturerProductApprovals";
import ManufacturerProductApprovalDetail from "./components/parts/manufacturer/approvals/ManufacturerProductApprovalDetail";
// import DistributorNavigation from "./components/layout/DistributorNavigation"; // DELETED
import RetailerNavigation from "./components/layout/RetailerNavigation";
import Navigation from "./components/layout/Navigation";
// Import configs
import { manufacturerNavigationItems, distributorNavigationItems, adminNavigationSections, partnerNavigationItems } from "./config/navigationConfig";
import { MdLogout } from "react-icons/md";
import AdminLayout from "./layouts/AdminLayout";
import AdminLanding from "./components/parts/admin/AdminLanding";
import AdminDashboard from "./components/parts/admin/AdminDashboard";
// import AdminNavigation from "./components/layout/AdminNavigation"; // DELETED
import AdminUsers from "./components/parts/admin/AdminUsers";
import AdminOrganizations from "./components/parts/admin/AdminOrganizations";
import AdminOrganizationApprovals from './components/parts/admin/AdminOrganizationApprovals';
import AdminOrganizationDetail from "./components/parts/admin/AdminOrganizationDetail";
import AdminPromotionTypes from "./components/parts/admin/AdminPromotionTypes";
import AdminCategoryMapper from "./components/parts/admin/AdminCategoryMapper";
import AdminScannedBills from "./components/parts/admin/AdminScannedBills";
import AdminScannedBillDetail from "./components/parts/admin/AdminScannedBillDetail";
import AdminAlerts from "./components/parts/admin/AdminAlerts";
import AdminNotificationLogs from "./components/parts/admin/AdminNotificationLogs";
import AdminFreshness from "./components/parts/admin/AdminFreshness";
import AdminTransactions from "./components/parts/admin/AdminTransactions";
import AdminPreparedTransactions from "./components/parts/admin/AdminPreparedTransactions";
import AdminFailedTransactions from "./components/parts/admin/AdminFailedTransactions";
import AdminRevenue from "./components/parts/admin/AdminRevenue";
import AdminBillingProfiles from "./components/parts/admin/AdminBillingProfiles";
import AdminPlanOffers from "./components/parts/admin/AdminPlanOffers";
import AdminBills from "./components/parts/admin/AdminBills";
import AdminInvoices from "./components/parts/admin/AdminInvoices";
import AdminContracts from "./components/parts/admin/AdminContracts";
import AdminReconciliation from "./components/parts/admin/AdminReconciliation";
import AdminIntegrationsOverview from "./components/parts/admin/AdminIntegrationsOverview";
import AdminIntegrationsList from "./components/parts/admin/AdminIntegrationsList";
import AdminIntegrationDetail from "./components/parts/admin/AdminIntegrationDetail";
import AdminWebhookHealth from "./components/parts/admin/AdminWebhookHealth";
import AdminIntegrationLogs from "./components/parts/admin/AdminIntegrationLogs";
import AdminSyncMonitor from "./components/parts/admin/AdminSyncMonitor";
import AdminQuotas from "./components/parts/admin/AdminQuotas";
import AdminCustomers from "./components/parts/admin/AdminCustomers";
import AdminVenues from "./components/parts/admin/AdminVenues";
import AdminVenueDetail from "./components/parts/admin/AdminVenueDetail";
import AdminCities from "./components/parts/admin/AdminCities";
import AdminScraperStaging from "./components/parts/admin/AdminScraperStaging";
import AdminScraperStagingDetail from "./components/parts/admin/AdminScraperStagingDetail";
import AdminCatalogOperations from "./components/parts/admin/AdminCatalogOperations";
import AdminNotifications from "./components/parts/admin/AdminNotifications";
import AdminGiveaways from "./components/parts/admin/AdminGiveaways";
import DeliverySettings from "./components/parts/Delivery/DeliverySettings";
import AdminGlobalPointsSettings from "./components/parts/admin/AdminGlobalPointsSettings";
import DistributorDashboard from "./components/parts/distributor/DistributorDashboard";
import DistributorManufacturers from "./components/parts/distributor/manufacturers/DistributorManufacturers";
import DistributorManufacturerDetail from "./components/parts/distributor/manufacturers/DistributorManufacturerDetail";
import DistributorRetailers from "./components/parts/distributor/retailers/DistributorRetailers";
import DistributorRetailerDetail from "./components/parts/distributor/retailers/DistributorRetailerDetail";
import DistributorVenues from "./components/parts/distributor/venues/DistributorVenues";
import DistributorVenueDetail from "./components/parts/distributor/venues/DistributorVenueDetail";
import DistributorTransactions from "./components/parts/distributor/transactions/DistributorTransactions";
import DistributorIntegrations from "./components/parts/distributor/integrations/DistributorIntegrations";
import DistributorImportExport from "./components/parts/distributor/importExport/DistributorImportExport";
import DistributorSettings from "./components/parts/distributor/settings/DistributorSettings";
import DistributorBestOffers from "./components/parts/distributor/DistributorBestOffers";
import DistributorDiscounts from "./components/parts/distributor/DistributorDiscounts";
import RetailerBestOffers from "./components/parts/retailer/RetailerBestOffers";
import RetailerDiscounts from "./components/parts/retailer/RetailerDiscounts";
import RetailerDistributors from "./components/parts/retailer/RetailerDistributors";
import RetailerDistributorDetail from "./components/parts/retailer/RetailerDistributorDetail";
import CrossSellEarnings from "./components/parts/CrossSell/CrossSellEarnings";
import OrganizationScannedBills from "./components/parts/ScannedBills/OrganizationScannedBills";
import OrganizationScannedBillDetail from "./components/parts/ScannedBills/OrganizationScannedBillDetail";
import RetailerBillApprovals from "./components/parts/ScannedBills/RetailerBillApprovals";
import RetailerBillApprovalDetail from "./components/parts/ScannedBills/RetailerBillApprovalDetail";
import PartnerDashboard from "./components/parts/partner/PartnerDashboard";

import LoadingScreen from "./components/common/LoadingScreen";
import WooCommerceConnect from "./components/parts/Integrations/WooCommerceConnect";

const AppRouter = () => {
    const { isAuthenticated, loading, user, isTransitioning } = useAuth(); // Access authentication state
    const location = useLocation(); // Get the current location
    const isSystemAdmin = Boolean(user?.is_system_admin);
    const isManufacturer = Boolean(user?.is_manufacturer_user);
    const isDistributor = Boolean(user?.is_distributor_user);
    const isPartner = Boolean(user?.is_partner_user);

    if (loading || isTransitioning) {
        return <LoadingScreen />;
    }

    return (
        <Routes>
            {isAuthenticated && <Route path="/connect/woocommerce" element={<WooCommerceConnect />} />}
            {isAuthenticated && <Route path="/connect/shopware" element={<WooCommerceConnect platform="shopware" />} />}
            {/* Non-authenticated routes */}
            {!isAuthenticated ? (
                <Route element={<AuthLayout />}>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/verify-email" element={<VerifyEmailResult />} />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Route>
            ) : isSystemAdmin ? (
                <Route element={<MainLayout NavigationComponent={(props) => <Navigation {...props} items={adminNavigationSections} density="compact" collapsibleSections logoutItem={{ labelKey: 'Navigation.logout', icon: <MdLogout className="icon" /> }} />} />}>
                    <Route path="/" element={<AdminDashboard />} />
                    <Route path="/users" element={<AdminUsers />} />
                    <Route path="/users/statistics" element={<AdminUsers defaultTab="stats" />} />
                    <Route path="/organizations" element={<AdminOrganizations />} />
                    <Route path="/organization-approvals" element={<AdminOrganizationApprovals />} />
                    <Route path="/organizations/:id" element={<AdminOrganizationDetail />} />
                    <Route path="/customers" element={<AdminCustomers />} />
                    <Route path="/venues" element={<AdminVenues />} />
                    <Route path="/venues/:id" element={<AdminVenueDetail />} />
                    <Route path="/cities" element={<AdminCities />} />
                    <Route path="/scraper-staging" element={<AdminScraperStaging />} />
                    <Route path="/scraper-staging/:id" element={<AdminScraperStagingDetail />} />
                    <Route path="/catalog-operations" element={<AdminCatalogOperations />} />
                    <Route path="/scanned-bills" element={<AdminScannedBills />} />
                    <Route path="/scanned-bills/:id" element={<AdminScannedBillDetail />} />
                    <Route path="/transactions" element={<AdminTransactions />} />
                    <Route path="/transactions/prepared" element={<AdminPreparedTransactions />} />
                    <Route path="/transactions/failed" element={<AdminFailedTransactions />} />
                    <Route path="/revenue" element={<AdminRevenue />} />
                    <Route path="/revenue/reconciliation" element={<AdminReconciliation />} />
                    <Route path="/billing/profiles" element={<AdminBillingProfiles />} />
                    <Route path="/plan-offers" element={<AdminPlanOffers />} />
                    <Route path="/billing/bills" element={<AdminBills />} />
                    <Route path="/billing/invoices" element={<AdminInvoices />} />
                    <Route path="/contracts" element={<AdminContracts />} />
                    <Route path="/integrations" element={<AdminIntegrationsOverview />} />
                    <Route path="/integrations/list" element={<AdminIntegrationsList />} />
                    <Route path="/integrations/:id" element={<AdminIntegrationDetail />} />
                    <Route path="/integrations/webhooks" element={<AdminWebhookHealth />} />
                    <Route path="/integrations/logs" element={<AdminIntegrationLogs />} />
                    <Route path="/integrations/sync" element={<AdminSyncMonitor />} />
                    <Route path="/integrations/quotas" element={<AdminQuotas />} />
                    <Route path="/alerts" element={<AdminAlerts />} />
                    <Route path="/freshness" element={<AdminFreshness />} />
                    <Route path="/notifications" element={<AdminNotifications />} />
                    <Route path="/notification-logs" element={<AdminNotificationLogs />} />
                    <Route path="/giveaways" element={<AdminGiveaways />} />
                    <Route path="/global-points-settings" element={<AdminGlobalPointsSettings />} />
                    <Route path="/promotions/types" element={<AdminPromotionTypes />} />
                    <Route path="/categories/mapping" element={<AdminCategoryMapper />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            ) : isPartner ? (
                <Route element={<MainLayout NavigationComponent={(props) => <Navigation {...props} items={partnerNavigationItems} logoutItem={{ labelKey: 'Navigation.logout', icon: <MdLogout className="icon" /> }} />} />}>
                    <Route path="/" element={<PartnerDashboard />} />
                    <Route path="retailers" element={<PartnerDashboard />} />
                    <Route path="users" element={<PartnerDashboard />} />
                    <Route path="installations" element={<PartnerDashboard />} />
                    <Route path="commissions" element={<PartnerDashboard />} />
                    <Route path="settings" element={<PartnerDashboard />} />
                    <Route path="profile" element={<PartnerDashboard />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            ) : isManufacturer ? (
                <Route element={<MainLayout NavigationComponent={(props) => <Navigation {...props} items={manufacturerNavigationItems} logoutItem={{ labelKey: 'ManufacturerNav.logout', icon: <MdLogout className="icon" /> }} />} />}>
                    <Route path="/" element={<ManufacturerDashboard />} />
                    <Route path="products" element={<ManufacturerProducts />} />
                    <Route path="products/:productId" element={<ManufacturerProductDetail />} />
                    <Route path="retailers" element={<ManufacturerRetailers />} />
                    <Route path="retailers/:retailerId" element={<ManufacturerRetailerDetail />} />
                    <Route path="distributors" element={<ManufacturerDistributors />} />
                    <Route path="distributors/:distributorId" element={<ManufacturerDistributorDetail />} />
                    <Route path="venues" element={<ManufacturerVenues />} />
                    <Route path="venues/:venueId" element={<ManufacturerVenueDetail />} />
                    <Route path="transactions" element={<ManufacturerTransactions />} />
                    <Route path="warranties" element={<ManufacturerWarrantiesPage />} />
                    <Route path="support" element={<ManufacturerSupport />} />
                    <Route path="integrations" element={<ManufacturerIntegrations />} />
                    <Route path="imports" element={<ManufacturerImportExport />} />
                    <Route path="compliance" element={<ManufacturerCompliance />} />
                    <Route path="discounts" element={<ManufacturerDiscounts />} />
                    <Route path="product-approvals" element={<ManufacturerProductApprovals />} />
                    <Route path="product-approvals/:id" element={<ManufacturerProductApprovalDetail />} />
                    <Route path="settings" element={<ManufacturerSettings />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            ) : isDistributor ? (
                <Route element={<MainLayout NavigationComponent={(props) => <Navigation {...props} items={distributorNavigationItems} logoutItem={{ labelKey: 'DistributorNav.logout', icon: <MdLogout className="icon" /> }} />} />}>
                    <Route path="/" element={<DistributorDashboard />} />
                    <Route path="best-offers" element={<DistributorBestOffers />} />
                    <Route path="manufacturers" element={<DistributorManufacturers />} />
                    <Route path="manufacturers/:manufacturerId" element={<DistributorManufacturerDetail />} />
                    <Route path="retailers" element={<DistributorRetailers />} />
                    <Route path="retailers/:retailerId" element={<DistributorRetailerDetail />} />
                    <Route path="venues" element={<DistributorVenues />} />
                    <Route path="venues/:venueId" element={<DistributorVenueDetail />} />
                    <Route path="transactions" element={<DistributorTransactions />} />
                    <Route path="discounts" element={<DistributorDiscounts />} />
                    <Route path="integrations" element={<DistributorIntegrations />} />
                    <Route path="imports" element={<DistributorImportExport />} />
                    <Route path="settings" element={<DistributorSettings />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            ) : (
                <Route element={<MainLayout NavigationComponent={RetailerNavigation} />}>
                    {/* Dashboard Route */}
                    <Route path="/" element={<Dashboard />} />
                    <Route path="best-offers" element={<RetailerBestOffers />} />
                    <Route path="distributors" element={<RetailerDistributors />} />
                    <Route path="distributors/:id" element={<RetailerDistributorDetail />} />
                    <Route path="cross-sell-earnings" element={<CrossSellEarnings />} />

                    {/* Other Routes */}
                    <Route path="customers" element={<Users />} />
                    <Route path="customers/:customerId" element={<CustomerDetails />} />
                    <Route path="users" element={<OrganizationUsers />} />
                    <Route path="transactions" element={<Transactions />} />

                    {/* Venues Routes */}
                    <Route path="venues">
                        <Route index element={<Venues />} />
                        <Route path="create" element={<VenueCreate />} />
                        <Route path="view/:id" element={<VenueView />} />
                    </Route>

                    {/* Items Routes */}
                    <Route path="items">
                        <Route index element={<Items />} />
                        <Route path="view/:itemId" element={<ViewItem />} />
                    </Route>
                    <Route path="products">
                        <Route index element={<Products />} />
                        <Route path=":productId" element={<ProductView />} />
                    </Route>
                    <Route path="discounts" element={<RetailerDiscounts />} />
                    <Route path="delivery" element={<DeliverySettings />} />
                    <Route path="warranties" element={<Warranties />} />
                    <Route path="campaigns">
                        <Route index element={<CampaignList />} />
                        <Route path="create" element={<CampaignCreate />} />
                        <Route path="edit/:id" element={<CampaignEdit />} />
                    </Route>

                    {/* Other Routes */}
                    <Route path="authorized_services" element={<AuthorizedServiceCenters />} />
                    <Route path="integration" element={<Integrations />} />
                    <Route path="setup" element={<RetailerSetup />} />
                    <Route path="/repair-services" element={<RepairSettingsPage />} />
                    <Route path="settings" element={<Settings />} />
                    <Route path="plan" element={<MyPlan />} />
                    <Route path="partner-referral" element={<RetailerPartnerReferral />} />
                    <Route path="catalog-sources" element={<Navigate to="/catalog-import" replace />} />
                    <Route path="catalog-import" element={<CatalogImportWorkspace />} />
                    <Route path="category-mappings" element={<RetailerCategoryMappings />} />
                    <Route path="discovery-stats" element={<DiscoveryStats />} />
                    <Route path="profile" element={<ProfilePage />} />
                    <Route path="organizations/:id" element={<OrganizationDetail />} />
                    <Route path="imports" element={<Navigate to="/catalog-import?view=upload" replace />} />
                    <Route path="scanned-bills" element={<OrganizationScannedBills />} />
                    <Route path="scanned-bills/:id" element={<OrganizationScannedBillDetail />} />
                    <Route path="bill-approvals" element={<RetailerBillApprovals />} />
                    <Route path="bill-approvals/:id" element={<RetailerBillApprovalDetail />} />

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            )}
        </Routes>
    );
};

export default AppRouter;
